import reducerRegistry from '@comeon/reducer-registry';
import { REDUCER_NAME } from './selectors';

export const TIME_LIMIT_EXCEEDED = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_EXCEEDED';
export const TIME_PLAYED = '@komigen/mobile-frontend/time-limit/time-limit/TIME_PLAYED';
export const TIME_TO_NEXT_SESSION = '@komigen/mobile-frontend/time-limit/time-limit/TIME_TO_NEXT_SESSION';
export const TIME_LIMIT_DATA_HYDRATED = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_DATA_HYDRATED';
export const TIME_LIMIT_DATA_UNHYDRATED = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_DATA_UNHYDRATED';
export const TIME_LIMIT_REACHED_TEXT = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_REACHED_TEXT';
export const TIME_LIMIT_ADD_TIMER = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_ADD_TIMER';
export const TIME_LIMIT_REFETCH = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_REFETCH';
export const TIME_LIMIT_RESET = '@komigen/mobile-frontend/time-limit/time-limit/TIME_LIMIT_RESET';
export const SET_PROACTIVE_TIME_LIMIT_WARNING_POPUP_DATA =
	'@komigen/mobile-frontend/time-limit/time-limit/SET_PROACTIVE_TIME_LIMIT_WARNING_POPUP_DATA';

const timeLimitHydrated = () => dispatch => {
	dispatch({ type: TIME_LIMIT_DATA_HYDRATED, payload: true });
};

const timeLimitUnHydrated = () => dispatch => {
	dispatch({ type: TIME_LIMIT_DATA_UNHYDRATED, payload: true });
};

const timeLimitExceeded = () => dispatch => {
	dispatch({ type: TIME_LIMIT_EXCEEDED });
};

const setTimeLimitTimePlayed = timePlayed => dispatch => {
	dispatch({ type: TIME_PLAYED, payload: timePlayed });
};

const setTimeLimitTimeToNextSession = timeLeft => dispatch => {
	dispatch({ type: TIME_TO_NEXT_SESSION, payload: timeLeft });
};

const setTimeLimitReachedText = timeLimitReachedText => dispatch => {
	dispatch({ type: TIME_LIMIT_REACHED_TEXT, payload: timeLimitReachedText });
};

const timeLimitAddTimer = timeLimitTimers => dispatch => {
	dispatch({ type: TIME_LIMIT_ADD_TIMER, payload: timeLimitTimers });
};

const timeLimitAddNewTimer = timeLimitTimer => (dispatch, getState) => {
	const state = getState();
	dispatch({ type: TIME_LIMIT_ADD_TIMER, payload: [...state.timeLimit.timeLimitTimers, timeLimitTimer] });
};

const timeLimitReset = () => (dispatch, getState) => {
	const state = getState();
	state.timeLimit.timeLimitTimers.forEach(timerId => {
		clearTimeout(timerId);
	});
	dispatch({ type: TIME_LIMIT_RESET });
};

const timeLimitRefetch = () => dispatch => {
	dispatch({ type: TIME_LIMIT_REFETCH });
};

const setProactiveTimeLimitWarningPopUpData = payload => ({
	type: SET_PROACTIVE_TIME_LIMIT_WARNING_POPUP_DATA,
	payload
});

const preloadedState = {
	refetchTimers: false,
	timeLimitExceeded: false,
	timeLimitHydrated: false,
	proactiveTimeLimitWarningPopUpData: null,
	timeLimitTimers: []
};

function reducer(state = preloadedState, { type, payload }) {
	switch (type) {
		case TIME_LIMIT_EXCEEDED:
			return { ...state, timeLimitExceeded: true };
		case TIME_PLAYED:
			return { ...state, timePlayed: payload };
		case TIME_TO_NEXT_SESSION:
			return { ...state, timeLeft: payload };
		case TIME_LIMIT_DATA_HYDRATED:
			return { ...state, timeLimitHydrated: true };
		case TIME_LIMIT_DATA_UNHYDRATED:
			return { ...state, timeLimitHydrated: false };
		case TIME_LIMIT_REACHED_TEXT:
			return { ...state, timeLimitReachedText: payload };
		case TIME_LIMIT_ADD_TIMER:
			return { ...state, timeLimitTimers: payload };
		case TIME_LIMIT_REFETCH:
			return { ...state, refetchTimers: true };
		case TIME_LIMIT_RESET:
			return { ...state, timeLimitTimers: [] };
		case SET_PROACTIVE_TIME_LIMIT_WARNING_POPUP_DATA:
			return { ...state, proactiveTimeLimitWarningPopUpData: payload };
		default:
			return state;
	}
}
reducerRegistry.register(REDUCER_NAME, reducer);
export {
	timeLimitExceeded,
	setTimeLimitTimePlayed,
	setTimeLimitTimeToNextSession,
	timeLimitHydrated,
	timeLimitUnHydrated,
	setTimeLimitReachedText,
	timeLimitAddTimer,
	timeLimitRefetch,
	timeLimitReset,
	timeLimitAddNewTimer,
	setProactiveTimeLimitWarningPopUpData
};

export default reducer;
